import { render, staticRenderFns } from "./News.vue?vue&type=template&id=2aa3bb78&scoped=true"
import script from "../script/news.js?vue&type=script&lang=js&external"
export * from "../script/news.js?vue&type=script&lang=js&external"
import style0 from "./News.vue?vue&type=style&index=0&id=2aa3bb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3bb78",
  null
  
)

export default component.exports